import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AmplifyAuthService } from '../services/amplify-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AmplifyAuthGuardService {
  constructor(
    private router: Router,
    private amplifyAuthService: AmplifyAuthService
  ) {}

  public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.amplifyAuthService
      .getCurrentUser()
      .then(() => true)
      .catch(() => {
        this.router.navigate(['/login']);

        return false;
      });
  }
}
